import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import classNames from 'classnames';

const UIDropdownFooter = ({
  className,
  children
}) => /*#__PURE__*/_jsx("div", {
  className: classNames('private-dropdown__footer-container', className),
  children: children
});

UIDropdownFooter.propTypes = {
  children: PropTypes.node
};
UIDropdownFooter.displayName = 'UIDropdownFooter';
export default UIDropdownFooter;